export enum EProjectType {
    single_media = 'single_media',
    multiple_media = 'multiple_media',
    embedded_video = 'embedded_video',
    long_screen = 'long_screen',
    triple_media = 'triple_media',
    slider = 'slider',
    text = 'text'
}

export enum ETextColor {
    BLACK = 'black',
    WHITE = 'white',
}
